import React, { useEffect, useRef } from 'react';
const VideoSafeContent = ({ htmlContent }) => {
    const containerRef = useRef(null);
    useEffect(() => {
        if (!containerRef.current || !htmlContent)
            return;
        // Clear previous content
        containerRef.current.innerHTML = '';
        // Set the innerHTML directly and let the browser handle the iframe naturally
        containerRef.current.innerHTML = htmlContent;
        // After setting innerHTML, find any iframes and ensure they have proper attributes
        const iframes = containerRef.current.querySelectorAll('iframe');
        iframes.forEach((iframe) => {
            const src = iframe.getAttribute('src');
            if (src && src.includes('vimeo.com')) {
                // Ensure the iframe has all necessary Vimeo attributes
                iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
                iframe.setAttribute('allowfullscreen', '');
                iframe.setAttribute('webkitallowfullscreen', '');
                iframe.setAttribute('mozallowfullscreen', '');
                // Ensure proper dimensions
                if (!iframe.getAttribute('width')) {
                    iframe.setAttribute('width', '100%');
                }
                if (!iframe.getAttribute('height')) {
                    iframe.setAttribute('height', '400');
                }
                if (!iframe.getAttribute('frameborder')) {
                    iframe.setAttribute('frameborder', '0');
                }
            }
        });
    }, [htmlContent]);
    return (React.createElement("div", { ref: containerRef, className: "video-safe-content" }));
};
export default VideoSafeContent;
